module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "regiment"
    }
  }, [_c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/intro-2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("TITLES OF THE REGIMENT")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v("1817"), _c('br'), _vm._v("Cuttack Legion")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1823"), _c('br'), _vm._v("Rangpur Local Battalion"), _c('br'), _vm._v("8th Rangpur Light Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1827"), _c('br'), _vm._v("Assam Light Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1861"), _c('br'), _vm._v("42nd Regiment of Bengal Native (Light) Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1865"), _c('br'), _vm._v("46th Regiment of Bengal Native Infantry"), _c('br'), _vm._v("42nd Assam Regiment of Bengal Native Light Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1885"), _c('br'), _vm._v("42nd Bengal Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1886"), _c('br'), _vm._v("42nd Gurkha Light Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1891"), _c('br'), _vm._v("42nd Gurkha Rifle Regiment of Bengal Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1901"), _c('br'), _vm._v("42nd Gurkha Rifles")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1903"), _c('br'), _vm._v("6th Gurkha Rifles")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_vm._v("1959"), _c('br'), _vm._v("6th Queen Elizabeth’s Own Gurkha Rifles")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/intro-3.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b87b42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/14_regiment.vue
// module id = 93
// module chunks = 0